import { useEffect } from 'react';
import posthogClient from 'posthog-js';
import { PostHogProvider as Provider, usePostHog, PostHogErrorBoundary } from '@posthog/react';

export { PostHogErrorBoundary };

if (typeof window !== 'undefined' && import.meta.env.PROD) {
  posthogClient.init(import.meta.env.VITE_POSTHOG_KEY || 'YOUR_POSTHOG_KEY', {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_performance: true,
    capture_pageview: false, // We'll handle this manually for better control
    loaded: (ph) => {
      if (import.meta.env.DEV) ph.debug();
    },
  });
}

// Optional: Component to track pageviews manually in SPAs
function PostHogPageView() {
  const ph = usePostHog();

  useEffect(() => {
    if (ph) {
      ph.capture('$pageview');
    }
  }, [ph]);

  return null;
}

export function PostHogProvider({ children }) {
  return (
    <Provider client={posthogClient}>
      <PostHogPageView />
      {children}
    </Provider>
  );
}
